import { QUEUED_AT } from "../constants";
import { getQueuedAtEpoch } from "../utils";

const initialState = {
  queuedAt: QUEUED_AT["6H"],
  queuedAtTimestamp: getQueuedAtEpoch(QUEUED_AT["6H"]),
  pendingCalls: 0,
  failedCalls: 0,
  completedCalls: 0,
  totalCalls: 0,
  concurrencyLimit: 3,
  concurrentCalls: 0,
  isLoading: true,
  lastUpdatedAt: Date.now(),
};

export { initialState };
